import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import About from "./pages/About";
import ServiceDetails from "./pages/ServiceDetails";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Services from "./pages/Services";
import logo from "./assets/logo-only.png";
import { I18nProvider } from "./i18n";
import ScrollToTop from "./components/ScrollToTop";
import LogisticsBackground from "./components/LogisticsBackground";
// import LogisticsIntro from "./components/LogisticsIntro";
function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <I18nProvider>
      <BrowserRouter>
       <LogisticsBackground />
      {/* <LogisticsIntro /> */}
       <ScrollToTop />
        {isLoading ? (
          <div className="loader-screen fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden bg-slate-50">
            {/* Abstract background */}
            <div
              aria-hidden="true"
              className="pointer-events-none absolute inset-0 overflow-hidden"
            >
              {/* Gradient glows */}
              <div className="loader-glow loader-glow-one absolute -right-40 -top-40 h-[32rem] w-[32rem] rounded-full bg-sky-200/50 blur-[110px]" />

              <div className="loader-glow loader-glow-two absolute -bottom-48 -left-40 h-[35rem] w-[35rem] rounded-full bg-blue-200/50 blur-[120px]" />

              <div className="loader-glow loader-glow-three absolute left-[35%] top-[20%] h-72 w-72 rounded-full bg-cyan-100/70 blur-[100px]" />

              {/* Subtle grid */}
              <div
                className="absolute inset-0 opacity-[0.045]"
                style={{
                  backgroundImage:
                    "linear-gradient(to right, #334155 1px, transparent 1px), linear-gradient(to bottom, #334155 1px, transparent 1px)",
                  backgroundSize: "55px 55px",
                }}
              />

              {/* Abstract lines */}
              <svg
                className="absolute inset-0 h-full w-full"
                viewBox="0 0 1440 900"
                preserveAspectRatio="xMidYMid slice"
                fill="none"
              >
                <defs>
                  <linearGradient
                    id="loaderLineGradient"
                    x1="0"
                    y1="0"
                    x2="1440"
                    y2="900"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#38BDF8" stopOpacity="0" />
                    <stop offset="0.5" stopColor="#38BDF8" stopOpacity="0.45" />
                    <stop offset="1" stopColor="#6366F1" stopOpacity="0" />
                  </linearGradient>
                </defs>

                <path
                  className="loader-wave"
                  d="M-200 650C100 450 300 850 600 600S1100 350 1600 550"
                  stroke="url(#loaderLineGradient)"
                  strokeWidth="1.5"
                />

                <path
                  className="loader-wave loader-wave-delay"
                  d="M-200 700C100 500 300 900 600 650S1100 400 1600 600"
                  stroke="url(#loaderLineGradient)"
                  strokeWidth="1"
                />

                <path
                  d="M-100 150C200 300 350 50 650 200S1100 350 1500 100"
                  stroke="url(#loaderLineGradient)"
                  strokeWidth="1.5"
                />

                {/* Decorative circles */}
                <circle
                  className="loader-orbit"
                  cx="1150"
                  cy="230"
                  r="100"
                  stroke="#38BDF8"
                  strokeOpacity="0.3"
                />

                <circle
                  className="loader-orbit loader-orbit-delay"
                  cx="1150"
                  cy="230"
                  r="130"
                  stroke="#38BDF8"
                  strokeOpacity="0.2"
                />

                <circle
                  cx="270"
                  cy="690"
                  r="85"
                  stroke="#6366F1"
                  strokeOpacity="0.2"
                />

                <circle
                  cx="270"
                  cy="690"
                  r="115"
                  stroke="#6366F1"
                  strokeOpacity="0.12"
                />
              </svg>

              {/* Soft white overlay */}
              <div className="absolute inset-0 bg-gradient-to-b from-white/10 via-transparent to-white/30" />
            </div>

            {/* Loader content */}
            <div className="loader-content relative z-10 flex flex-col items-center">
              {/* Logo and rings */}
              <div className="relative flex h-36 w-36 items-center justify-center md:h-44 md:w-44">
                {/* Outer animated ring */}
                <div className="loader-ring absolute inset-0 rounded-full border-2 border-slate-200 border-t-sky-500" />

                {/* Inner ring */}
                <div className="loader-ring-inner absolute inset-2 rounded-full border border-sky-400/30" />

                {/* Glow behind logo */}
                <div className="loader-logo-glow absolute h-24 w-24 rounded-full bg-sky-300/40 blur-2xl md:h-32 md:w-32" />

                {/* Logo */}
                <img
                  src={logo}
                  alt="Seaway Logistics"
                  className="loader-logo relative z-10 w-20 object-contain md:w-28"
                />
              </div>

              {/* Brand name */}
              <div className="loader-brand mt-6 text-center">
                <span className="text-2xl font-extrabold uppercase tracking-wide text-slate-900 md:text-4xl">
                  Seaway{" "}
                  <span className="text-sky-600">Logistics</span>
                </span>

                {/* Loading indicator */}
                <div className="mx-auto mt-5 h-1 w-36 overflow-hidden rounded-full bg-slate-200 md:w-48">
                  <div className="loader-progress h-full rounded-full bg-gradient-to-r from-sky-400 via-blue-500 to-sky-400" />
                </div>
              </div>
            </div>

            {/* CSS animations */}
            <style>{`
              .loader-glow {
                will-change: transform;
              }

              .loader-glow-one {
                animation: loaderGlowOne 10s ease-in-out infinite;
              }

              .loader-glow-two {
                animation: loaderGlowTwo 13s ease-in-out infinite;
              }

              .loader-glow-three {
                animation: loaderGlowThree 9s ease-in-out infinite;
              }

              @keyframes loaderGlowOne {
                0%, 100% {
                  transform: translate(0, 0) scale(1);
                }
                50% {
                  transform: translate(-35px, 30px) scale(1.12);
                }
              }

              @keyframes loaderGlowTwo {
                0%, 100% {
                  transform: translate(0, 0) scale(1);
                }
                50% {
                  transform: translate(30px, -25px) scale(1.1);
                }
              }

              @keyframes loaderGlowThree {
                0%, 100% {
                  transform: translate(0, 0);
                }
                50% {
                  transform: translate(20px, 30px);
                }
              }

              .loader-ring {
                animation: loaderSpin 2s linear infinite;
              }

              .loader-ring-inner {
                animation: loaderSpin 5s linear infinite reverse;
              }

              @keyframes loaderSpin {
                to {
                  transform: rotate(360deg);
                }
              }

              .loader-logo-glow {
                animation: loaderLogoGlow 2s ease-in-out infinite;
              }

              @keyframes loaderLogoGlow {
                0%, 100% {
                  opacity: 0.45;
                  transform: scale(0.9);
                }
                50% {
                  opacity: 1;
                  transform: scale(1.15);
                }
              }

              .loader-wave {
                stroke-dasharray: 12 16;
                animation: loaderWave 18s linear infinite;
              }

              .loader-wave-delay {
                animation-duration: 24s;
                animation-direction: reverse;
              }

              @keyframes loaderWave {
                to {
                  stroke-dashoffset: -560;
                }
              }

              .loader-orbit {
                transform-origin: 1150px 230px;
                animation: loaderOrbit 24s linear infinite;
              }

              .loader-orbit-delay {
                animation-duration: 32s;
                animation-direction: reverse;
              }

              @keyframes loaderOrbit {
                to {
                  transform: rotate(360deg);
                }
              }

              .loader-content {
                animation: loaderAppear 0.8s cubic-bezier(0.22, 1, 0.36, 1) both;
              }

              @keyframes loaderAppear {
                from {
                  opacity: 0;
                  transform: translateY(18px);
                  filter: blur(8px);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                  filter: blur(0);
                }
              }

              .loader-logo {
                animation: loaderLogoAppear 0.9s ease-out 0.15s both;
              }

              @keyframes loaderLogoAppear {
                from {
                  opacity: 0;
                  transform: scale(0.8);
                }
                to {
                  opacity: 1;
                  transform: scale(1);
                }
              }

              .loader-brand {
                animation: loaderBrandAppear 0.8s ease-out 0.3s both;
              }

              @keyframes loaderBrandAppear {
                from {
                  opacity: 0;
                  transform: translateY(12px);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }

              .loader-progress {
                width: 40%;
                animation: loaderProgress 1.5s ease-in-out infinite;
              }

              @keyframes loaderProgress {
                0% {
                  transform: translateX(-110%);
                }
                100% {
                  transform: translateX(360%);
                }
              }

              @media (prefers-reduced-motion: reduce) {
                .loader-glow,
                .loader-ring,
                .loader-ring-inner,
                .loader-logo-glow,
                .loader-wave,
                .loader-orbit,
                .loader-content,
                .loader-logo,
                .loader-brand,
                .loader-progress {
                  animation: none !important;
                }

                .loader-content,
                .loader-logo,
                .loader-brand {
                  opacity: 1;
                  transform: none;
                  filter: none;
                }
              }
            `}</style>
          </div>
        ) : (
          <div className="site-content">
            <Routes>
              <Route element={<Header />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/:id" element={<ServiceDetails />} />
                <Route path="/contact" element={<Contact />} />
              </Route>
            </Routes>
          </div>
        )}
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;